export const supportedCompareAccountColors = ['#ff2b52', '#40b87c', '#966acc', '#3892e5', '#ffbe82', '#15cccf'];

export const getCompareAccountColorOpacity = (color: string) => color + '80';
